import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Card, PageHeader } from "../../components/dashboard/DashboardShell";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { fmtDate } from "../../lib/format";

export default function AccountPage() {
  const { user, setUser } = useAuth();
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: () => api.get("/meta").then((r) => r.data), staleTime: Infinity });
  const [f, setF] = useState({ name: user.name || "", phone: user.phone || "", city: user.city || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!f.name.trim()) return toast.error("Nama tidak boleh kosong");
    setBusy(true);
    try { const { data } = await api.put("/users/me", f); setUser(data); toast.success("Profil disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div>
      <PageHeader title="Akun Saya" subtitle="Kelola informasi profil Anda." />
      <div className="grid lg:grid-cols-3 gap-4">
        <Card>
          <div className="flex flex-col items-center text-center py-2">
            <img src={user.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=2563eb&color=fff`} alt={user.name} className="w-24 h-24 rounded-full object-cover" />
            <p className="text-lg font-extrabold text-slate-900 mt-4">{user.name}</p>
            <p className="text-xs text-slate-500">{user.email}</p>
            <span className="mt-3 text-[11px] font-bold bg-blue-50 text-blue-600 rounded-full px-3 py-1 capitalize">{user.role}</span>
            <p className="text-[11px] text-slate-400 mt-4">Bergabung {fmtDate(user.created_at)}</p>
          </div>
        </Card>
        <Card title="Informasi Profil" className="lg:col-span-2">
          <div className="grid sm:grid-cols-2 gap-4" data-testid="account-form">
            <div><label className="text-xs font-bold text-slate-600">Nama lengkap</label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="mt-1.5" data-testid="account-name" /></div>
            <div><label className="text-xs font-bold text-slate-600">Email</label><Input value={user.email} disabled className="mt-1.5 bg-slate-50" /></div>
            <div><label className="text-xs font-bold text-slate-600">No. HP / WhatsApp</label><Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="08xx-xxxx-xxxx" className="mt-1.5" data-testid="account-phone" /></div>
            <div>
              <label className="text-xs font-bold text-slate-600">Kota</label>
              <Select value={f.city || undefined} onValueChange={(v) => setF({ ...f, city: v })}>
                <SelectTrigger className="mt-1.5" data-testid="account-city"><SelectValue placeholder="Pilih kota" /></SelectTrigger>
                <SelectContent>{meta?.cities?.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
          <Button onClick={save} disabled={busy} data-testid="account-save-btn" className="mt-5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl h-10 px-5 text-sm">
            {busy ? <Loader2 size={14} className="animate-spin mr-2" /> : <Save size={14} className="mr-2" />} Simpan Perubahan
          </Button>
        </Card>
      </div>
    </div>
  );
}
